import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';

type HeaderContentProps = React.HTMLAttributes<HTMLDivElement> & {
  hasContent?: boolean;
};

const HeaderContent = forwardRef<HTMLDivElement, HeaderContentProps>(({ children, hasContent, ...props }, ref) => (
  <div
    ref={ref}
    data-has-content={hasContent || undefined}
    className={cx('relative flex justify-center items-center', {
      'h-[var(--navigation-header-height)] py-4 md:py-3': hasContent,
      'py-2 md:py-1.5': !hasContent,
    })}
    {...props}
  >
    {children}
  </div>
));

export default HeaderContent;
